var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-editor-container"},[_c('EditorContent',{staticClass:"prosemirror-wrapper",attrs:{"editor":_vm.viewer,"spellcheck":"false"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }